<section class="page-offset section-pad">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-5">
        <div class="soft-card bg-white p-4 p-md-5 text-center">
          @if (errorMessageKey() || errorMessage()) {
            <div class="alert alert-danger text-start">{{ errorMessageKey() ? i18n.t(errorMessageKey()) : errorMessage() }}</div>
            <a class="btn btn-primary" routerLink="/login">Back to login</a>
          } @else if (needsXEmail()) {
            <div class="text-start">
              <p class="text-uppercase text-primary fw-bold small mb-2">X</p>
              <h1 class="h4 fw-bold mb-2">{{ i18n.t('auth.xEmailTitle') }}</h1>
              <p class="text-secondary mb-4">{{ i18n.t('auth.xEmailHelp') }}</p>
              <form (ngSubmit)="submitXEmail()">
                <p class="required-fields-notice text-secondary small bg-light rounded-3 p-3 mb-3">{{ i18n.t('common.requiredFieldsNotice') }}</p>
                <label class="form-label" for="xEmail">{{ i18n.t('signup.emailAddress') }}<span class="required-star" aria-hidden="true">*</span></label>
                <input id="xEmail" class="form-control form-control-lg mb-2" type="email" name="xEmail" [(ngModel)]="xEmail" autocomplete="email" required [disabled]="isSubmittingEmail">
                <div class="form-text mb-4">{{ i18n.t('auth.xProfileEmailHelp') }}</div>
                <button class="btn btn-primary btn-lg w-100" type="submit" [disabled]="isSubmittingEmail || !xEmail.trim()" [attr.aria-busy]="isSubmittingEmail">
                  @if (isSubmittingEmail) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> }
                  {{ isSubmittingEmail ? i18n.t('auth.completingXSignIn') : i18n.t('auth.finishXSignIn') }}
                </button>
              </form>
            </div>
          } @else {
            <div class="spinner-border text-primary mb-3" role="status" [attr.aria-label]="'Completing ' + providerLabel() + ' sign-in'"></div>
            <h1 class="h4 fw-bold mb-2">Completing {{ providerLabel() }} sign-in…</h1>
            <p class="text-secondary mb-0">Please wait while PhD Compass signs you in.</p>
          }
        </div>
      </div>
    </div>
  </div>
</section>